module.exports = __webpack_public_path__ + "static/media/video.b3739ef3.mp4";